// extracted by mini-css-extract-plugin
export default {"header":"BOaPmjPe6FLKIvDT9GOE","search":"vrdFFxN_7YfWBtOHZldo"};